/**
  * course模块接口列表
  */

import base from './base'; // 导入接口域名列表
import axios from '@/axios'; // 导入axios实例
import qs from 'qs';
//let path = base.default+'/ArtAppWeb/rest';
//let path = '/Portal'; //ArtAppInst2
let path = base.default;

const obj = {

    //查询机构列表（本地机构，地图展示）
    userAddressSelectAllUserAddressDetailList2(params) {
        return axios.get(`${path}/userAddress/selectAllUserAddressDetailList2`, {params:params});
    },
    //获取美育地图上的工作室点
    selectStudioListForMap(params){
        return axios.post(`${path}/artmapOfStudioEvaluation/selectStudioListForMap`,qs.stringify(params)); //机构
    },
    //查询机构列表(废弃)
    userAddressSelectAllUserAddressDetailListOfPage(params) {
        return axios.get(`${path}/userAddress/selectAllUserAddressDetailListOfPage`, {params:params});
    },
    //获取机构详情
    artmap2SelectUserAddressById(params) {
        return axios.post(`${path}/artmap2/selectUserAddressById`, qs.stringify(params));
    },
    //查询小黑板
    artmap2SelectBlackboardByAddressId(params) {
        return axios.post(`${path}/artmap2/selectBlackboardByAddressId`, qs.stringify(params));
    },
    //查询教学成果
    artmap2SelectAddressTeachResultList(params) {
        return axios.post(`${path}/artmap2/selectAddressTeachResultList`, qs.stringify(params));
    },
    //查询招聘老师
    artmap2SelectAddressJobList(params) {
        return axios.post(`${path}/artmap2/selectAddressJobList`, qs.stringify(params));
    },

    //查询工作室列表
    artmapOfStudioEvaluationSelectStudioList(params) {
        return axios.get(`${path}/artmapOfStudioEvaluation/selectStudioList`, {params:params});
    },

}

export default obj;
